export let languages = [
    {
        id: 1,
        name: "English",
        suffix: "en"
    },
    {
        id: 2,
        name: "Русский",
        suffix: "ru"
    },
    {
        id: 3,
        name: "O'zbek",
        suffix: "uz"
    }
];
